import { useState, useContext } from 'react';
import { HeaderContext } from '@contexts/HeaderContext';

const transformLanguage = (sportData) => {
    const [state] = useContext(HeaderContext);
    const enContext = {
        league: sportData.LeagueEn || sportData.CompetitionName,
        homeTeam: sportData.HomeTeam.NameEn || sportData.HomeTeam.Name,
        awayTeam: sportData.AwayTeam.NameEn || sportData.AwayTeam.Name,
    };
    const csContext = {
        league: sportData.LeagueZh || sportData.LeagueCn || sportData.CompetitionName,
        homeTeam: sportData.HomeTeam.NameZh || sportData.HomeTeam.NameCn || sportData.HomeTeam.Name,
        awayTeam: sportData.AwayTeam.NameZh || sportData.AwayTeam.NameCn || sportData.AwayTeam.Name,
    };

    const languageContext = {
        en: enContext,
        ch: csContext,
        cs: csContext,
        zhcn: csContext,
        jp: enContext,
        ko: enContext,
        th: enContext,
        vn: enContext,
        id: enContext,
        mm: enContext,
    }[state.language];

    return { languageContext };
};

export default transformLanguage;
